import React from 'react';
import PoeticHeroSlider from './ui/PoeticHeroSlider';

function App() {
  return (
    // The main container fills the viewport (iframe) completely
    <main className="h-screen w-full bg-[#1a2e22] overflow-hidden">
      <PoeticHeroSlider height="h-full" overlayOpacity={0.45} />
    </main>
  );
}

export default App;